
const getNodeIdFromUiFormat = (nodeIdUiFormat) => {
    try {
        return parseInt(nodeIdUiFormat.replace("-node", ""));
    } catch (error) {
        console.error("Error parsing node ID:", error);
    }
}


const getParentsNode = (nodeId, adjacency, nodes) => {
    const parents = [];
    for (const node of nodes) {
        const tempNodeId = getNodeIdFromUiFormat(node.id);
        if (adjacency[tempNodeId][nodeId] == 1) {
            parents.push(node);
        }
    }
    return parents;
}

const getAncerstorNodes = (nodes, edges, targetNodeId, parentId) => {

    if (!targetNodeId && !parentId) {
        return nodes;
    }

    try {
        const currentNodeId = targetNodeId || parentId;
        const isFromParent = parentId != null && parentId != undefined;
        const ancestors = new Set();
        let parents = [];
        const adjacency = {};

        for (const nodeA of nodes) {
            const idA = getNodeIdFromUiFormat(nodeA.id);
            adjacency[idA] = {}
            for (const nodeB of nodes) {
                const idB = getNodeIdFromUiFormat(nodeB.id);
                adjacency[idA][idB] = 0;
            }
        }

        for (const edge of edges) {
            const source = getNodeIdFromUiFormat(edge.source);
            const target = getNodeIdFromUiFormat(edge.target);
            adjacency[source][target] = 1;
        }

        parents.push(currentNodeId);
        while (parents.length > 0) {
            const aux = new Set();
            for (const nodeId of parents) {
                const auxParents = getParentsNode(nodeId, adjacency, nodes)
                for (const parent of auxParents) {
                    ancestors.add(parent.remoteId);
                    aux.add(parent.remoteId);
                }
            }
            parents = Array.from(aux);
        }

        const response = [];
        for (const ancestor of ancestors) {
            for (const node of nodes) {
                if (node.remoteId == ancestor) {
                    response.push(node);
                }
            }
        }

        if (isFromParent) {
            const parentNode = nodes.find(node => getNodeIdFromUiFormat(node.id) == parentId);
            if (parentNode) {
                response.push(parentNode);
            }
        }

        return response;
        
    } catch (error) {
        console.error("Error getting Ancerstor nodes:", error);
        return nodes;
    }
}


export { getAncerstorNodes }